import { defineMessages } from 'react-intl';

export const autoSyncStatusMessages = defineMessages({
  disabled: {
    id: 'app.inventory.autoSync.disabled',
  },
  failed: {
    id: 'app.inventory.autoSync.failed',
  },
  idle: {
    id: 'app.inventory.autoSync.idle',
  },
  running: {
    id: 'app.inventory.autoSync.running',
  },
  synced: {
    id: 'app.inventory.autoSync.synced',
  },
});

export const messages = defineMessages({
  appCommonBack: {
    id: 'app.common.back',
  },
  languageTitle: {
    id: 'app.inventory.language.title',
  },
  settingsApiBaseUrl: {
    id: 'app.inventory.settings.apiBaseUrl',
  },
  settingsApiBaseUrlPlaceholder: {
    id: 'app.inventory.settings.apiBaseUrlPlaceholder',
  },
  settingsApiConfigured: {
    id: 'app.inventory.settings.apiConfigured',
  },
  settingsApiMissing: {
    id: 'app.inventory.settings.apiMissing',
  },
  settingsApiTitle: {
    id: 'app.inventory.settings.apiTitle',
  },
  settingsAutoSync: {
    id: 'app.inventory.settings.autoSync',
  },
  settingsAutoSyncDescription: {
    id: 'app.inventory.settings.autoSyncDescription',
  },
  settingsAutoSyncStatus: {
    id: 'app.inventory.settings.autoSyncStatus',
  },
  settingsDefaultApiBaseUrl: {
    id: 'app.inventory.settings.defaultApiBaseUrl',
  },
  settingsDescription: {
    id: 'app.inventory.settings.description',
  },
  settingsErrorLoadSettings: {
    id: 'app.inventory.settings.errorLoadSettings',
  },
  settingsErrorSaveSettings: {
    id: 'app.inventory.settings.errorSaveSettings',
  },
  settingsErrorClearLocalData: {
    id: 'app.inventory.settings.errorClearLocalData',
  },
  settingsFieldInventory: {
    id: 'app.inventory.settings.fieldInventory',
  },
  settingsClearLocalData: {
    id: 'app.inventory.settings.clearLocalData',
  },
  settingsClearLocalDataConfirm: {
    id: 'app.inventory.settings.clearLocalDataConfirm',
  },
  settingsClearLocalDataPrompt: {
    id: 'app.inventory.settings.clearLocalDataPrompt',
  },
  settingsLocalDataCleared: {
    id: 'app.inventory.settings.localDataCleared',
  },
  settingsLocalDataDescription: {
    id: 'app.inventory.settings.localDataDescription',
  },
  settingsLocalDataTitle: {
    id: 'app.inventory.settings.localDataTitle',
  },
  settingsNoDefaultApiBaseUrl: {
    id: 'app.inventory.settings.noDefaultApiBaseUrl',
  },
  settingsSavedAt: {
    id: 'app.inventory.settings.savedAt',
  },
  settingsSaveSettings: {
    id: 'app.inventory.settings.saveSettings',
  },
  settingsTitle: {
    id: 'app.inventory.settings.title',
  },
  settingsUseViteDefault: {
    id: 'app.inventory.settings.useViteDefault',
  },
});
